<article class="alert" role="alert" [ngClass]="'alert--' + status()">
  @if (title(); as title) {
    <h2 class="fs-body-sm font-secondary fw-bold mb-2">{{ title }}</h2>
  }
  @if (message(); as message) {
    <p class="mb-0">{{ message }}</p>
  }

  @if (html() || '' | stripHtml) {
    <app-markdown [content]="html()!" />
  }

  <ng-content />
</article>
